/**
 * WebStorage wrapper to match AsyncStorage API for web compatibility
 */
export const WebStorage = {
  getItem: async (key: string): Promise<string | null> => {
    try {
      return Promise.resolve(localStorage.getItem(key));
    } catch (error) {
      console.error('WebStorage getItem error:', error);
      return Promise.resolve(null);
    }
  },

  setItem: async (key: string, value: string): Promise<void> => {
    try {
      localStorage.setItem(key, value);
      return Promise.resolve();
    } catch (error) {
      console.error('WebStorage setItem error:', error);
      return Promise.reject(error);
    }
  },

  removeItem: async (key: string): Promise<void> => {
    try {
      localStorage.removeItem(key);
      return Promise.resolve();
    } catch (error) {
      console.error('WebStorage removeItem error:', error);
      return Promise.reject(error);
    }
  },

  clear: async (): Promise<void> => {
    try {
      localStorage.clear();
      return Promise.resolve();
    } catch (error) {
      console.error('WebStorage clear error:', error);
      return Promise.reject(error);
    }
  },

  multiGet: async (keys: string[]): Promise<[string, string | null][]> => {
    try {
      const results: [string, string | null][] = keys.map(key => [
        key,
        localStorage.getItem(key)
      ]);
      return Promise.resolve(results);
    } catch (error) {
      console.error('WebStorage multiGet error:', error);
      return Promise.reject(error);
    }
  },

  multiSet: async (keyValuePairs: [string, string][]): Promise<void> => {
    try {
      keyValuePairs.forEach(([key, value]) => {
        localStorage.setItem(key, value);
      });
      return Promise.resolve();
    } catch (error) {
      console.error('WebStorage multiSet error:', error);
      return Promise.reject(error);
    }
  },

  multiRemove: async (keys: string[]): Promise<void> => {
    try {
      keys.forEach(key => {
        localStorage.removeItem(key);
      });
      return Promise.resolve();
    } catch (error) {
      console.error('WebStorage multiRemove error:', error);
      return Promise.reject(error);
    }
  },

  getAllKeys: async (): Promise<string[]> => {
    try {
      const keys = Object.keys(localStorage);
      return Promise.resolve(keys);
    } catch (error) {
      console.error('WebStorage getAllKeys error:', error);
      return Promise.reject(error);
    }
  }
};

export default WebStorage;